/* eslint-disable no-debugger */
import Vue from 'vue'
import App from './App.vue'
import router from './routes'
import store from './store'
import api from "./services/api"
import moment from 'moment'
import VueConfirmDialog from 'vue-confirm-dialog'
import axios from 'axios'
import Vuelidate from 'vuelidate'

Vue.config.productionTip = false
Vue.use(VueConfirmDialog)
Vue.use(Vuelidate)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

Vue.prototype.$http = api;
Vue.prototype.moment = moment;



axios.interceptors.request.use(
  config => {
    store.commit('setLoading', true);
    if (store.state.token !== undefined) {
      config.headers['authorization'] = store.state.token;
    }
    return config;
  },
  error => {
    Promise.reject(error)
  });

axios.interceptors.response.use((response) => {
  store.commit('setLoading', false);
  return response;
}, (error) => {
  store.commit('setLoading', false);
  if (error.response.status !== 401) {
    return new Promise((resolve, reject) => {
      reject(error);
    });
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')